<template>
  <el-menu
      :collapse="isCollapse"
      class="el-menu-vertical-demo"
      unique-opened @select="handleSelect"
      background-color="#031120"
      text-color="#fff"
      active-text-color="#ffd04b"
      :default-active="active"
  >
    <h3 class="app-title" v-if="!isCollapse">蜜蜂<br/>Wellorg</h3>
    <h3 class="app-title" v-else>W</h3>

    <template v-for="(route, index) in this.$router.options.routes">
      <!--如果是单项菜单-->
      <el-menu-item v-if="!route.children && !route?.meta?.hidden" :key="route.path" :index="route.name">
        <div class="menu-item-content">
          <img v-if="route.meta?.iconPath" :src="require('@/assets/icons/' + route.meta.iconPath)" class="menu-icon"/>
          <i v-else :class="route.meta?.icon"></i>
          <span>{{ route.name }}</span>
        </div>
      </el-menu-item>
      <!--如果是嵌套菜单-->
      <el-submenu v-else-if="!route?.meta?.hidden" :key="route.path" :index="route.name">
        <template slot="title">
          <div class="menu-item-content">
            <img v-if="route.meta?.iconPath" :src="require('@/assets/icons/' + route.meta.iconPath)" class="menu-icon"/>
            <i v-else :class="route.meta?.icon"></i>
            <span>{{ route.name }}</span>
          </div>
        </template>
        <template v-for="(child, j) in route.children">
          <el-menu-item v-if="!child.children && !child?.meta?.hidden" :key="child.path"
                        :index="child.name">
            {{ child.name }}
          </el-menu-item>
          <el-submenu v-else-if="!child?.meta?.hidden" :key="child.path"
                      :index="child.name">
            <template slot="title">
              <span>{{ child.name }}</span>
            </template>
            <el-menu-item v-for="(grandChild, k) in child.children" :key="grandChild.path" :index="grandChild.name"
                          v-if="!grandChild?.meta?.hidden">
              {{ grandChild.name }}
            </el-menu-item>
          </el-submenu>
        </template>
      </el-submenu>
    </template>

    <div class="sidebar-version" :title="'版本 ' + buildVersion">
      <span v-if="!isCollapse">版本 {{ buildVersion }}</span>
      <span v-else>v{{ buildSequence }}</span>
    </div>
  </el-menu>
</template>


<script>

// noinspection JSUnusedLocalSymbols
export default {
  name: 'SideMenu',
  data() {
    return {
      active: "",
      buildVersion: process.env.VUE_APP_BUILD_VERSION || '20261020-01',
    };
  },

  computed: {
    buildSequence() {
      const parts = this.buildVersion.split('-');
      return parts.length > 1 ? parts[parts.length - 1] : this.buildVersion;
    },
  },

  props: {
    // 接收来自父组件的 isCollapse prop
    isCollapse: {
      type: Boolean,
      default: false // 默认值设置为 false，以防父组件没有传递这个 prop
    }
  },

  async created() {
    this.active = this.$route.name;
  },

  methods: {
    handleSelect(key, keyPath) {
      if (this.$route.name !== key) {
        this.$router.push({name: key});
      }
    },
  },
  watch: {
    '$route'(to, from) {
      this.active = to.name;
    }
  },

};
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
/* 删除 min-height: 3400px; 以允许flex-grow工作 */
.el-menu-vertical-demo:not(.el-menu--collapse) {
  flex-grow: 1; /* 新增这行 */
}

.app-title {
  margin: 23px;
  color: rgb(86, 101, 115);
  font-size: 22px;
  line-height: 27px;
}

/* 确保.el-menu-vertical-demo始终占满整个高度 */
.el-menu-vertical-demo {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: rgb(47, 64, 80);
}

.menu-item-content {
  display: flex;
  align-items: center;
  justify-content: start;
}

.menu-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-left: 3px;
}

.sidebar-version {
  flex: 0 0 auto;
  margin-top: auto;
  padding: 14px 8px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.56);
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
}


</style>
